import React from 'react';

import * as S from './styles';

interface ISectionContentProps {
  title: string;
  actions?: React.ReactNode;
}

const SectionContent: React.FC<ISectionContentProps> = ({
  title,
  actions,
  children,
}) => (
  <S.Container>
    <header>
      <h3>{title}</h3>

      <div>{actions}</div>
    </header>

    {children}
  </S.Container>
);

export default SectionContent;
